import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import RatingBar from "@/components/RatingBar";
import { RATING_DIMENSIONS } from "@/constants/ratings";
import type { Company } from "@/types";

interface AverageRatingsPanelProps {
  averageRatings: NonNullable<Company["averageRatings"]>;
}

export default function AverageRatingsPanel({
  averageRatings,
}: AverageRatingsPanelProps) {
  const { t } = useTranslation();

  return (
    <>
      <Typography
        variant="h5"
        sx={{
          fontWeight: 700,
          mb: 3,
        }}
      >
        {t("company.ratings")}
      </Typography>
      {RATING_DIMENSIONS.map(({ key, labelKey }) => (
        <RatingBar key={key} label={t(labelKey)} value={averageRatings[key]} />
      ))}
    </>
  );
}
